import { showToast } from "../../Utils/toast";
import { chooseStrategy } from "../../Utils/djAlgos";

export const BEATS_PER_BAR = 4;

export const fmt = (ms) => {
  if (ms == null) return "-";
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const mediaErrorMessage = (err) => {
  if (!err) return "Unknown playback error";
  switch (err.code) {
    case 1: return "Playback aborted";
    case 2: return "Network error while loading";
    case 3: return "Audio decoding failed";
    case 4: return "Audio source not supported or missing";
    default: return err.message || "Unknown playback error";
  }
};

export const reportAudioError = (side, track, err) => {
  const title = track?.title ? `"${track.title}"` : `Deck ${side}`;
  showToast.error(`Deck ${side} — ${mediaErrorMessage(err)}: ${title}`);
};

export const resolveStrategy = (djStore, outBpm, inBpm) => {
  if (djStore.strategyOverride !== "auto") {
    const picked = djStore.strategyOverride;
    djStore.setStrategyOverride("auto");
    return picked;
  }
  return chooseStrategy(outBpm, inBpm);
};

export function findNextBeat(beats, nowMs) {
  if (!beats) return null;
  for (const b of beats) if (b >= nowMs) return b;
  return null;
}

export function findNextDownbeat(beats, nowMs) {
  if (!beats) return null;
  for (let i = 0; i < beats.length; i++) {
    if (i % BEATS_PER_BAR === 0 && beats[i] >= nowMs) return beats[i];
  }
  return null;
}

export function lastBeatAtOrBefore(beats, atMs) {
  if (!beats || !beats.length) return null;
  let lo = 0;
  let hi = beats.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (beats[mid] <= atMs) lo = mid + 1;
    else hi = mid;
  }
  return lo > 0 ? beats[lo - 1] : null;
}

export function nearestBeat(beats, atMs) {
  if (!beats || !beats.length) return null;
  let best = beats[0];
  let bestDiff = Math.abs(beats[0] - atMs);
  for (const b of beats) {
    const d = Math.abs(b - atMs);
    if (d < bestDiff) {
      best = b;
      bestDiff = d;
    }
  }
  return best;
}
